import React from 'react';
import './App.css';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import Home from './Home';
import Wordle from './Wordle';

export default function App() {

  return (
    <div>
        <Router>
            <Switch>
                <Route exact path="/">
                    <Home/>
                </Route>
                <Route path="/Wordle">
                  <Wordle/>
                </Route>
            </Switch>
        </Router>
    </div>
  );
}
